import { PGetAllAnonymeAsync } from '@/api/facture/index';
import { formatDate, formatNombre, formatDateBack } from '@/services/general/general';
import genererCritereRechercheFacture from '@/services/general/genererCritereRechercheFacture';
import * as allTypes from '../mutation-type';
import * as types from './facture-mutation-type';
import {
  ETAT_PAYE, ETAT_ENREGISTRE, FACTURE_ETAT,
} from '../../api/config/facture/factureConf';

function initialState() {
  return {
    listesFactures: [],
    critereRecherche: genererCritereRechercheFacture(),
    totalFactures: 0,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach((key) => {
      state[key] = s[key];
    });
  },
  [allTypes.RESET_NOT_PERSISTED](state) {
    const s = initialState();
    Object.keys(state).forEach((key) => {
      state[key] = s[key];
    });
  },
  [types.SET_LISTES_FACTURES](state, listesFactures) {
    state.listesFactures = listesFactures;
  },
  [types.SET_CRITERE_RECHERCHE](state, critereRecherche) {
    state.critereRecherche = critereRecherche;
  },
  [types.SET_TOTAL_FACTURES](state, totalFactures) {
    state.totalFactures = totalFactures;
  },
};

const actions = {
  recupererFactureClients: async ({
    commit, getters, rootGetters,
  }, payload) => {
    let tiersIds = rootGetters['user/tiersId'];
    if (rootGetters['user/isSuperAdmin']) {
      if (rootGetters['dataTiers/pdvsInit'].length) {
        tiersIds = rootGetters['dataTiers/pdvsInit'].map(el => el.id);
      }
    }

    let etatsDevisCommandeFacture;
    switch (getters.critereRecherche.etat) {
      case null:
        etatsDevisCommandeFacture = [ETAT_ENREGISTRE, ETAT_PAYE];
        break;
      case ETAT_PAYE:
        etatsDevisCommandeFacture = [ETAT_PAYE];
        break;
      default:
        etatsDevisCommandeFacture = [getters.critereRecherche.etat];
    }

    const query = {
      query: {
        annonceurTiersIds: tiersIds,
        etat: etatsDevisCommandeFacture,
        dates: {
          dateDebut: getters.critereRecherche.dates.dateDebut
            ? formatDateBack(getters.critereRecherche.dates.dateDebut) : null,
          dateFin: getters.critereRecherche.dates.dateFin
            ? formatDateBack(getters.critereRecherche.dates.dateFin) : null,
        },
        auto: getters.critereRecherche.codeFacture ? getters.critereRecherche.codeFacture : '',
      },
      limit: payload.limit,
      page: payload.page,
      sorting: 'dateDevisCommande DESC',
    };
    const response = (await PGetAllAnonymeAsync(
      payload.hash,
      query,
    )).data.result;
    const data = response.items.map(fact => {
      let etatAffiche;
      switch (fact.etat) {
        case ETAT_PAYE:
          etatAffiche = FACTURE_ETAT.find(etat => etat.code === ETAT_PAYE).libelle;
          break;
        case ETAT_ENREGISTRE:
          etatAffiche = FACTURE_ETAT.find(etat => etat.code === ETAT_ENREGISTRE).libelle;
          break;
        default:
          break;
      }

      return {
        codeFact: fact.code,
        cheminPdf: fact.chemin,
        montantHT: formatNombre(fact.montantHT),
        dateFacture: formatDate(fact.dateDevisCommande),
        etat: etatAffiche,
        pointDeVente: {
          libelle: fact.intervenants.find(pdv => pdv.annonceur === true).nomCommercial,
          chemin: fact.intervenants.find(pdv => pdv.annonceur === true).chemin,
        },
      };
    });
    commit('SET_LISTES_FACTURES', data);
    commit('SET_TOTAL_FACTURES', response.totalCount);
  },
};

const getters = {
  listesFactures: (state) => state.listesFactures,
  critereRecherche: (state) => state.critereRecherche,
  totalFactures: (state) => state.totalFactures,
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
